import type { TourActivity } from '@carboncopyco/data';
import { TextBase, TextCaption, TooltipBubble } from '@carboncopyco/ui';
import { secondsToHHmmss } from '@carboncopyco/utils';
import type { Col } from '../../../FixedTable';
import { CompletedStepsCol } from '../../../InfoPage/TourPage';
import { AssetNameLink } from '../../AssetNameLink';
import type { DashboardProps } from '../../Dashboard';
import { TimestampCol } from '../../SessionBreakdownComponents';

export const toursBreakdownCols: (
  tourPagePath: DashboardProps['tourPagePath']
) => Col<TourActivity>[] = (tourPagePath) => [
  {
    alignment: 'left',
    title: 'Date & time',
    width: 180,
    maxContentWidth: 150,
    render: ({ timestamp }) => <TimestampCol timestamp={timestamp} />,
  },
  {
    alignment: 'left',
    title: 'Visitor',
    width: 180,
    maxContentWidth: 150,
    render: ({ user }) => (
      <div className="flex flex-col justify-center h-10">
        <TooltipBubble
          title={user?.name}
          placement="top-start"
          disabled={!user?.name}
        >
          <div className="truncate">
            <TextBase
              label={user?.name || 'Anonymous'}
              color="text-ds-natural-600"
              ellipsis
            />
          </div>
        </TooltipBubble>
        <TooltipBubble
          title={user?.email}
          placement="top-start"
        >
          <div className="truncate text-ds-natural">
            <TextCaption
              label={user?.email}
              ellipsis
            />
          </div>
        </TooltipBubble>
      </div>
    ),
  },
  {
    alignment: 'left',
    title: 'Tour name',
    width: 200,
    render: ({ asset }) => (
      <AssetNameLink
        truncateWidth={160}
        asset={asset}
        label={asset.name}
        assetType="tour"
        to={tourPagePath(asset.assetId, asset.workspaceId)}
      />
    ),
  },
  {
    alignment: 'left',
    title: 'Link name',
    width: 200,
    maxContentWidth: 170,
    render: ({ share }) => {
      return (
        <TooltipBubble
          title={share.shareName}
          placement="top-start"
          disabled={!share.shareName}
        >
          <div className="truncate">
            <TextBase
              label={share.shareName}
              color="text-ds-natural-600"
              ellipsis
            />
          </div>
        </TooltipBubble>
      );
    },
  },
  {
    alignment: 'right',
    title: 'Duration',
    width: 120,
    render: (tour) => (
      <TextBase
        label={secondsToHHmmss(tour.durationInSeconds)}
        color="text-ds-natural-600"
      />
    ),
  },
  {
    alignment: 'right',
    title: 'Completed steps',
    width: 200,
    render: ({ completedSteps, totalSteps }) => (
      <CompletedStepsCol
        completedSteps={completedSteps}
        stepsCount={totalSteps}
      />
    ),
  },
];
